export enum PermissionTypes {
	GESTORI_SISTEMA = "gestori_sistema",
	PIANIFICATORI = "pianificatori",
	SCHEDULATORI = "schedulatori",
	COMMERCIALI = "commerciali",
	GRUPPO_UNDERCONSTRUCTION = "gruppo_underconstruction",
	TICKETING_ASSISTENZA = "ticketing_assistenza",
	TICKETING_UTENTI = "ticketing_utenti",
	ALL = "all",
}

// export const PROGRAMMA_INCASSETTAMENTO_PERMISSIONS = [
// 	PermissionTypes.PIANIFICATORI,
// 	PermissionTypes.OPERATORI_MACELLO,
// 	PermissionTypes.SCHEDULATORI_LAVORAZIONI,
// 	PermissionTypes.SCHEDULATORI_ESTERNI,
// ];
